import {OrderItem} from "../../../../objects/orders/orderItem";
import {TaxType} from "../../../../objects/orders/taxType";
import {Tax} from "../../../../objects/orders/tax";
import {Order} from "../../../../objects/orders/order";
import {CurrencyEnum} from "../../../../objects/products/currencyEnum";
import {LocationUtil} from "../../../../common/utils/LocationUtil";
import {CanadianCurrencyCode} from "../../../../objects/currencyExchange/canadianCurrencyCode";
import {CalculatorHelper} from "../../../../common/helpers/calculatorHelper";
import { Input } from "@angular/core";
import {DutyType} from "../../../../objects/calculator/duty";
/**
 * Created by alex.y on 8/11/2017.
 */
export class BaseCalculatorTab {

    public locationUtil = LocationUtil;
    public currencyEnum = CurrencyEnum;
    @Input()
    public isPublic : boolean = false;
    public taxType = TaxType;
    public calculatorHelper = CalculatorHelper;

    public findTax(taxType: TaxType, orderItem: OrderItem): Tax {
        let result = orderItem.Total.Taxes.find(x => x.Type == taxType);

        if (!result)
            return new Tax();

        return result;
    }

    public hasManualDuty(orderItem: OrderItem): boolean {
        if(orderItem == null || orderItem.DutyList == null)
            return false;

        for(let duty of orderItem.DutyList) {
            if(duty.DutyType == DutyType.Manual)
                return true;
        }

        return false;
    }

    public calculateGrantTotalForItem(orderItem: OrderItem, order: Order): number {
        return CalculatorHelper.calculateGrantTotalForItem(orderItem, order);
    }

    public getCurrency(currency: string): string {
        if (String.isNullOrEmpty(currency)) {
            return 'CAD';
        }

        return currency;
    }

    public getCurrencyRate(orderItemCurrency: CanadianCurrencyCode, orderCurrency: CanadianCurrencyCode): number {
        if (orderCurrency == null)
            return orderItemCurrency.Value;

        if (orderItemCurrency.Code == orderCurrency.Code)
            return 1;

        return orderItemCurrency.Value / orderCurrency.Value;
    }

    public getCadValue(price: number, orderItemCurrency: CanadianCurrencyCode, orderCurrency: CanadianCurrencyCode): number {
        if (orderCurrency == null)
            return price * orderItemCurrency.Value;

        let rate: number = orderItemCurrency.Value / orderCurrency.Value;

        if (orderItemCurrency.Code == orderCurrency.Code)
            rate = 1;

        return price * rate;
    }

    public findTaxesSum(orderItem: OrderItem, taxTypes: Array<number> = []): number {
        let firstTotalTax: number = 0;

        for (let txtType of taxTypes) {
            firstTotalTax += this.findTax(txtType, orderItem).Value;
        }

        return firstTotalTax;
    }

    public findTaxesPersentSum(orderItem: OrderItem, taxTypes: Array<number> = []): number {
        let firstTotalTax: number = 0;

        for (let txtType of taxTypes) {
            firstTotalTax += this.findTax(txtType, orderItem).Percentage;
        }

        return firstTotalTax;
    }
}


// WEBPACK FOOTER //
// ./app/components/calculator/tabs/calculatorResults/baseCalculatorTab.ts